import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridButton, GridOptions, GridToolbarButton } from '@app/core/components/grid/grid.types';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-email-grid',
    templateUrl: './email-grid.component.html',
    styleUrls: ['./email-grid.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class EmailGridComponent implements OnChanges {
    grid?: GridOptions;

    @Input()
    rememberId: string = '';

    @Input()
    argType: string = '';

    @Input()
    argValue: string | number = '';

    @Input()
    webpage: string = '';

    @Output()
    gridReady = new EventEmitter<GridOptions>();

    constructor(private state: StateService) {}

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(this.rememberId)
                .setLoadDataFunction({ method: 2971, parameters: () => ({ [this.argType]: this.argValue }) })
                .setCustomToolbarButtons([this.buildNewEmailToolbarButton()]);
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private buildNewEmailToolbarButton(): GridToolbarButton {
        return {
            name: 'new_email',
            text: 'new_email',
            translate: true,
            func: () => {
                this.state.go('emailcreate', {
                    webpage: this.webpage,
                    argtype: this.argType,
                    argvalue: this.argValue,
                });
            },
            icon: 'fa-plus',
            cssClass: 'tt-button tt-button--primary im-grid-btn-xs-l',
        };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['webpage'] || !!changes['argType'] || !!changes['argValue']) {
            this.readGrid();
        }
    }
}
